<template>
  <div class="question-nair">
    <div class="common-width">
      <div class="common-main-body">
        <div v-if="openSurvey">
          <div wzades="情景导办" aria-label="情景导办">
            <div class="common-main-title">
              情景导办
              <div class="check-detail-guide common-fr">
                <el-button type="text" @click="showResetDialog">重置问卷</el-button>
              </div>
            </div>
            <div class="question-content" v-loading="surveyLoading > 0" element-loading-text="数据加载中……">
              <div class="common-tips">
                <div class="icon el-icon-warning"></div>
                <div class="text" v-if="baseInfo.surveyEnable == 1">
                  请回答以下问题，系统将为您筛选出可办理的事项及需提交的材料。
                </div>
                <div class="text" v-else-if="baseInfo.surveyAddEnable == 1">
                  选择导办问卷后可查看应办清单和应交材料。
                </div>
              </div>
              <ul class="content-box">
                <!--残疾人服务一件事：户籍地永远处于第一题，无需判断出现时机-->
                <li v-if="baseInfo.serviceCode == 'FCZKYJS'">
                  <!--题目问题-->
                  <h4 class="question">
                    <i class="common-required"></i>
                    1、请填写申请人的户籍地
                  </h4>
                  <div>
                    <el-cascader
                      :key="cascaderKey"
                      ref="areaCascader"
                      class="area-cascader"
                      placeholder="请选择申请人的户籍地"
                      v-model="jcAreaSeqs"
                      :props="{
                        lazy: true,
                        label: 'areaName',
                        value: 'areaCode',
                        lazyLoad: lazyLoad,
                        checkStrictly:true
                      }"
                      @expand-change="handleExpandChange">
                    </el-cascader>
                  </div>
                </li>
                <template v-for="topic of topicList">
                  <li :key="topic.seq" v-if="topic.hiddenStatus != 2">
                    <!--题目问题-->
                    <h4 class="question" v-if="topic.seq">
                      <i class="common-required" v-if="topic.required===1"></i>
                      {{ topic.index }}、{{ topic.topicName }}
                      <template v-if="topic.topicType===1">（单选）</template>
                      <template v-else-if="topic.topicType===2">（多选）</template>
                    </h4>
                    <div v-if="topic.tipsContent" class="question-tips">{{ topic.tipsContent }}</div>
                    <!--单选-->
                    <div class="radio-row" v-if="topic.topicType===1">
                      <!--使用自动应答后，不可编辑-->
                      <el-radio-group v-model="topic.answer" @change="radioChange(topic)" :disabled="topic.disabled">
                          <span v-for="option in topic.options" :key="option.seq">
                              <el-radio class="answer radioOptions common-ellipsis"
                                        :style="{'display': option.optionName.length > 32 ? 'block' : 'inline-block'}"
                                        :label="option.seq">{{ option.optionName }}
                              </el-radio>
                              <div v-if="option.lineBreak == 1" v-html="`\n`"></div>
                          </span>
                      </el-radio-group>
                    </div>
                    <!--多选-->
                    <div class="checkbox-row" v-else-if="topic.topicType === 2">
                      <el-checkbox-group v-model="topic.answer">
                        <span v-for="option in topic.options" :key="option.seq">
                            <el-checkbox class="checkboxOptions"
                                         v-model="option.seq"
                                         @change="(checked)=>checkboxChange(topic, option, checked)"
                                         :style="{'display': option.optionName.length > 32 ? 'block' : 'inline-block'}"
                                         :label="option.seq">{{ option.optionName }}
                                <div class="checkbox__isChecked"
                                     v-if="topic.answer.indexOf(option.seq) > -1">
                                    <i class="el-icon-check"></i>
                                </div>
                            </el-checkbox>
                            <div v-if="option.lineBreak == 1" v-html="`\n`"></div>
                        </span>
                      </el-checkbox-group>
                    </div>
                    <!--选项提示语-->
                    <template v-if="Object.keys(topic.promptContents).length">
                      <div class="warning-panel no-stop" v-for="(promptContent, optionSeq) in topic.promptContents" :key="optionSeq">
                        <span class="text">温馨提示：{{ promptContent }}</span>
                      </div>
                    </template>
                    <!--选项校验结果描述-->
                    <template v-if="Object.keys(topic.resultDesc).length">
                      <div class="warning-panel no-stop" v-for="(resultDesc, optionSeq) in topic.resultDesc" :key="optionSeq">
                        <span class="text">{{ resultDesc }}</span>
                      </div>
                    </template>
                    <!--选项终止导办提示-->
                    <template v-if="Object.keys(topic.terminationTips).length">
                      <div class="warning-panel" v-for="(tips, optionSeq) in topic.terminationTips"
                           :key="optionSeq">
                        <span class="icon">
                            <i class="el-icon-warning"></i>
                        </span>
                        <span class="text">{{ tips }}</span>
                      </div>
                    </template>
                  </li>
                </template>
                <li v-if="showChooseOrg">
                  <!--题目问题-->
                  <h4 class="question">
                    <i class="common-required"></i>
                    {{ extraTopicIndex }}、社保受理机构
                  </h4>
                  <div>
                    <el-select
                      class="area-cascader"
                      placeholder="请选择社保受理机构"
                      v-model="org"
                      value-key="agencyCode"
                      :disabled="orgOptions.length == 1"
                      @change="handleOptionItemsStuffs">
                      <el-option
                        v-for="item in orgOptions"
                        :key="item.agencyCode"
                        :label="item.agencyName"
                        :value="item">
                      </el-option>
                    </el-select>
                  </div>
                </li>
                <li v-if="showChooseJyjgArea">
                  <h4 class="question">
                    <i class="common-required"></i>
                    {{ extraTopicIndex }}、请填写就业服务机构所在地
                  </h4>
                  <div class="question-tips">题目说明：请从户籍地、居住地中选择其中一个所在地填写。</div>
                  <div>
                    <el-cascader
                      ref="jyjgAreaCascader"
                      class="area-cascader"
                      placeholder="请选择就业服务机构所在地"
                      v-model="jyjgAreas"
                      :props="{
                        lazy: true,
                        label: 'areaName',
                        value: 'areaCode',
                        lazyLoad: lazyLoadJyjg
                      }"
                      @expand-change="handleExpandChange">
                    </el-cascader>
                  </div>
                </li>
                <li v-if="showChooseSydjArea">
                  <h4 class="question">
                    <i class="common-required"></i>
                    {{ showChooseJyjgArea ? extraTopicIndex + 1 : extraTopicIndex }}、请填写失业登记地
                  </h4>
                  <div class="question-tips">题目说明：请从户籍地、居住地、就业地、参保地中选择其中一个所在地填写。</div>
                  <div>
                    <el-cascader
                      ref="sydjAreaCascader"
                      class="area-cascader"
                      placeholder="请选择失业登记地"
                      v-model="sydjAreas"
                      :props="{
                        lazy: true,
                        label: 'areaName',
                        value: 'areaCode',
                        lazyLoad: lazyLoadSydj
                      }"
                      @expand-change="handleExpandChange">
                    </el-cascader>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!--加法问卷初始状态不展示这块内容-->
        <div v-if="baseInfo.surveyAddEnable != 1 || !surveyAddInit" style="margin-top: -15px">
          <!--可办理事项-->
          <div wzades="可办理事项" aria-label="可办理事项">
            <div class="common-main-title">可办理事项</div>
            <div v-if="!optionItems.length">
              该场景下无可办理事项
            </div>
            <template v-else>
              <div class="common-tips" v-if="itemTips">
                <div class="icon el-icon-warning"></div>
                <div class="text">
                  {{ itemTips }}
                </div>
              </div>
              <el-table v-if="baseInfo.surveyOpenChose == 1" stripe ref="itemsTable" :data="optionItems"
                        class="common-stripe-table" empty-text="暂无可办理事项" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
                <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
                <el-table-column label="事项名称" prop="itemDirName">
                  <template slot-scope="scope">
                    <div class="stuff-name-container">
                      <div class="stuff-name common-ellipsis" :title="scope.row.itemDirName">
                        {{ scope.row.itemDirName }}
                      </div>
                      <span v-if="scope.row.needFlag" class="stuff-tab stuff-tab-blue">必须办理</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-table v-else stripe ref="itemsTable" :data="optionItems"
                        class="common-stripe-table" empty-text="暂无可办理事项">
                <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
                <el-table-column label="事项名称" prop="itemDirName">
                  <template slot-scope="scope">
                    <div class="stuff-name-container">
                      <div class="stuff-name common-ellipsis" :title="scope.row.itemDirName">
                        {{ scope.row.itemDirName }}
                      </div>
                      <span v-if="scope.row.needFlag" class="stuff-tab stuff-tab-blue">必须办理</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>

          <!--申请材料-->
          <div wzades="需提交材料" aria-label="需提交材料">
            <div v-loading="stuffLoading > 0" element-loading-text="数据加载中……"
                 element-loading-custom-class="stuff-loading">
              <div class="common-main-title">
                需提交材料
              </div>
              <div v-if="!optionStuffs.length">
                该场景下无应交材料
              </div>
              <el-table v-else :data="optionStuffs" stripe class="common-stripe-table">
                <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
                <el-table-column label="材料名称" prop="stuffName">
                  <template slot-scope="scope">
                    <div class="stuff-name-container">
                      <div class="stuff-name">
                        {{ scope.row.stuffName }}
                      </div>
                      <el-tooltip v-if="scope.row.licenseItemCode" content="如持有电子证照，将无需准备纸质版材料" placement="top">
                        <span class="stuff-tab stuff-tab-green">已关联电子证照</span>
                      </el-tooltip>
                      <el-tooltip v-if="scope.row.bindFormCode" content="本材料支持在线填表，无需纸质材料" placement="top">
                        <span class="stuff-tab stuff-tab-blue">在线填写</span>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="材料形式" prop="stuffType" width="200"
                                 :formatter="stuffTypeFormatter"></el-table-column>
                <el-table-column label="纸质材料要求" width="300">
                  <template slot-scope="scope">
                    <div v-if="scope.row.orginNum">原件：{{ scope.row.orginNum }}份</div>
                    <div v-if="scope.row.orginCopyNum">复印件：{{ scope.row.orginCopyNum }}份</div>
                    <div  v-else-if="!scope.row.orginNum">--</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-dropdown placement="bottom" @command="handleCommand($event, scope.row)"
                                 v-if="scope.row.kbAttaPath || scope.row.ylAttaPath">
                      <el-button type="text">范本下载</el-button>
                      <el-dropdown-menu class="custom-dropdown" slot="dropdown">
                        <el-dropdown-item command="1" v-if="scope.row.ylAttaPath">示例范本</el-dropdown-item>
                        <el-dropdown-item command="2" v-if="scope.row.kbAttaPath">空白范本</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <span v-else>--</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class="common-bottom">
        <div class="common-width">
          <el-button v-if="openSurvey" @click="showResetDialog">重置问卷</el-button>
          <el-button type="primary" class="next-btn" @click="beforeSubmitNair">立即办理</el-button>
        </div>
      </div>

      <el-dialog
        title="确认重置"
        :show-close="false"
        :visible.sync="resetDialogVisible"
        width="480px"
        class="common-confirm-dialog center"
        :close-on-click-modal="false"
        center>
        <div>即将清除您所选择的答案，是否继续重置？</div>
        <span slot="footer" class="dialog-footer">
					<el-button @click="reset(false)">取 消</el-button>
					<el-button type="primary" @click="reset(true)">确 定</el-button>
				</span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  fetchData,
} from '@/utils/ajax';
import {
  doSaveSnapshot,
  loadSurveyInfo,
  loadNextTopicByOption,
  loadParamByKey,
  queryHandleVerify,
  querySurveyItemList,
  querySurveyStuffList,
  checkItemApplyEnable,
  queryAcceptAgency,
  loadBaseAreaList,
  loadCJRInfo,
  getResidentPopulationInfo,
} from "@/utils/indexUrl";
import {loadSSInfo, loadStatementCheckConfig, verifyFormAndStuff} from "@/utils/jointApplyUrl";
import {Loading, Message, MessageBox} from "element-ui";
import Banner from '@/components/Banner';
import ShowMore from '@/components/ShowMore';
import {buriedPointFunc} from "../../../assets/utils/buriedPoint";
import {methodsBuriedPoint} from "../../../assets/utils/utils";
import {encryptByAES, decryptByAES, commonDownloadFile, handleBodyTransform, analyzeIDCardAge, getURLParams} from "@/utils/utils.js";
let curExpandNodes = []
let questionFormSeq = ''// 问卷seq
let sSInfo = {} //主题快照信息
let cjrInfo = null // 残疾人证信息
export default {
  name: 'questionNair',
  data() {
    return {
      topicList: {}, // 题目列表，topic seq作为键，topic object作为值
      baseInfo: JSON.parse(sessionStorage.getItem('baseInfo')),
      resetDialogVisible: false, // 展示重置弹框
      optionItems: [], // 可办理事项
      chosenItemDirCodes: [], // 可办理事项(用户选择后)
      optionStuffs: [], // 需提交材料
      stuffLoading: 0, // 大于0时正在加载材料
      surveyLoading: 0, // 大于0时正在加载问卷内容
      surveyAddInit: true, // 加法问卷初始状态
      extraTopicIndex: '',
      cascaderKey: Math.random(),
      jcAreaSeqs: [],
      jyjgAreas: [],
      sydjAreas: [],
      org: null, // 社保受理机构（企业职工退休一件事）
      orgOptions: [],// 社保受理机构下拉数据
      showChooseJyjgArea: false,// 是否展示就业服务机构所在地选择
      showChooseSydjArea: false,// 是否展示失业登记地选择
    };
  },
  computed: {
    hasTerminationTips() {
      let tips = 0;
      let topics = Object.values(this.topicList);
      for (let i = 0; i < topics.length; i++) {
        let topic = topics[i];
        if (Object.keys(topic.terminationTips).length) {
          tips = 1;
          break;
        } else if (topic.required == 1 && !topic.answer.length) {
          tips = 2;
          break;
        }
      }
      return tips;
    },
    openSurvey() {
      return this.baseInfo.surveyEnable == 1 || this.baseInfo.surveyAddEnable == 1;
    },
    // 是否展示社保受理机构
    showChooseOrg() {
      if (this.baseInfo.serviceCode !== 'QYZGTXYJS') {
        return false;
      }
      if (this.openSurvey) {
        if (this.hasTerminationTips == 1) { // 选了终止导办的选项
          return false;
        } else if (this.hasTerminationTips == 2) { // 未完成必选题目
          return false;
        }
      }
      if (!this.optionItems.length && !this.org) { // 未选择社保受理机构时 已经 无可办理事项
        return false;
      }
      return true;
    },
    itemTips() {
      if (this.baseInfo.serviceCode != 'FCZKYJS') {
        return ''
      }
      let tips = ''
      // “《中华人民共和国残疾人证》新办证申请” 442169016000
      if (this.optionItems.some(item => item.itemDirCode == '442169016000')) {
        tips += '选择办理的事项涉及到评定环节的，申请人提交的办理申请受理通过之后，需要按照指引前往残疾评定定点机构进行残疾评定。'
      }
      // "困难残疾人生活补贴发放" 440508024000
      // "重度残疾人护理补贴发放" 440508025000
      // "城乡居民养老保险参保登记" 442111750001
      if (this.optionItems.some(item => item.itemDirCode == '440508024000' || item.itemDirCode == '440508025000' || item.itemDirCode == '442111750001')) {
        tips += '在业务办理期间，被民政部门认定为最低生活保障人员、最低生活保障边缘家庭成员、特困供养人员、孤儿和事实无人抚养儿童的人员，可按规定享受医保部门给予的相应医疗救助待遇。'
      }
      return tips
    }
  },
  watch: {
    hasTerminationTips() {
      this.handleJyjgAreaVisible()
      this.handleSydjAreaVisible()
    },
    showChooseOrg(val) {
      if (!val) {
        this.org = null;
      } else {
        this.loadOrgOptionList();
      }
    }
  },
  methods: {
    handleBodyTransform,
    handleExpandChange(arr) {
      curExpandNodes = arr;
    },
    _loadBaseAreaList(node) {
      const {level, data, path} = node;
      let params;
      if (level == 0) {
        params = {
          areaCode: '440000000000'
        }
      } else {
        params = {
          parentSeq: data.seq,
          areaType: path[1] == "441900000000" || path[1] == "442000000000" ? level + 3 : level + 2 // 东莞/中山跳过区级
        }
      }
      return loadBaseAreaList(params)
    },
    handleSelectionChange(arr) {
      this.chosenItemDirCodes = arr;
      let topicOptionSeqs = this.getTopicOptionSeqs()
      this._querySurveyStuffList(topicOptionSeqs);
    },
    /**
     * @description: 是否禁止勾选
     * @param {Object} row 当前行数据
     * @param {Number} index 行下标
     */
    selectable(row, index) {
      return row.needFlag == 0;
    },
    lazyLoad(node, resolve) {
      this._loadBaseAreaList(node).then(res => {
        if (res.status == '200') {
          if (!res.data?.length) { // 下一层级无数据就直接选中
            this.jcAreaSeqs = curExpandNodes.concat([node.value]);
            this.handleOptionItemsStuffs();
            this.$refs.areaCascader.dropDownVisible = false;
          }
          resolve(res.data);
        }
      });
    },
    lazyLoadJyjg(node, resolve) {
      // 就业机构只需要选到镇街
      const {level, path} = node;
      if (level == 4 || level == 3 && (path[1] == "441900000000" || path[1] == "442000000000")) {
          this.jyjgAreas = curExpandNodes.concat([node.value]);
          this.handleOptionItemsStuffs();
          this.$refs.jyjgAreaCascader.dropDownVisible = false;
          resolve([]);
          return false
      }
      this._loadBaseAreaList(node).then(res => {
        if (res.status == '200') {
          if (!res.data?.length) { // 下一层级无数据就直接选中
            this.jyjgAreas = curExpandNodes.concat([node.value]);
            this.handleOptionItemsStuffs();
            this.$refs.jyjgAreaCascader.dropDownVisible = false;
          }
          resolve(res.data);
        }
      });
    },
    lazyLoadSydj(node, resolve) {
      // 失业登记地只需要选到镇街
      const {level, path} = node;
      if (level == 4 || level == 3 && (path[1] == "441900000000" || path[1] == "442000000000")) {
        this.sydjAreas = curExpandNodes.concat([node.value]);
        this.handleOptionItemsStuffs();
        this.$refs.sydjAreaCascader.dropDownVisible = false;
        resolve([]);
        return false
      }
      this._loadBaseAreaList(node).then(res => {
        if (res.status == '200') {
          if (!res.data?.length || node.level == 6) { // 下一层级无数据就直接选中
            this.sydjAreas = curExpandNodes.concat([node.value]);
            this.handleOptionItemsStuffs();
            this.$refs.sydjAreaCascader.dropDownVisible = false;
          }
          resolve(res.data);
        }
      });
    },
    // 对选中的答案做校验
    async checkAnswer(option) {
      if (option.optionCheck != 1) {
        return ''
      }
      try {
        let url = option.optionCheckUrl.split('?')[0]
        let params = getURLParams(option.optionCheckUrl)
          if (sessionStorage.getItem('proposerInfo')) {
              let proposerInfo = JSON.parse(sessionStorage.getItem('proposerInfo'));
              params.agentCardId = encryptByAES(proposerInfo.custCardId);
              params.agentMan = encryptByAES(proposerInfo.custContactPerson);
          }
        let res = await fetchData(url, params, 'post', null, (data) => { return data });
        if (res.status == '200') {
          return res.data
        } else {
          throw new Error(res.desc)
        }
      } catch (e) {
        console.log(e)
        return ''
      }

    },
    // 单选题答案变化
    async radioChange(topic) {
      await this._loadNextTopicByOption(topic, topic.options.find(option => option.seq == topic.answer));
      this.handleOptionItemsStuffs();
    },
    // 多选题答案变化
    async checkboxChange(topic, option, checked) {
      await this._loadNextTopicByOption(topic, option, checked);
      this.handleOptionItemsStuffs();
    },
    getTopicOptionSeqs() {
      let topicOptionSeqs = [];
      Object.values(this.topicList).forEach(topic => {
        if (topic.answer) {
          if (Array.isArray(topic.answer)) {
            topic.answer = topic.answer.filter(optionSeq => {
              return !topic.terminationTips[optionSeq] && !topic.resultDesc[optionSeq]
            })
            topicOptionSeqs = topicOptionSeqs.concat(topic.answer);
          } else {
            if (!topic.terminationTips[topic.answer] && !topic.resultDesc[topic.answer]) {
              topicOptionSeqs.push(topic.answer);
            }
          }
        }
      });
      return topicOptionSeqs
    },
    handleOptionItemsStuffs() {
        // 当问卷结果包含“终止导办”时，清空可办事项清单和材料清单
        if (this.hasTerminationTips == 1) {
            this.optionItems = []
            this.optionStuffs = []
            return false
        }
      this.surveyAddInit = false;
      let topicOptionSeqs = this.getTopicOptionSeqs()
      this._querySurveyItemList(topicOptionSeqs);
    },
    // 获取社保受理机构
    loadOrgOptionList() {
      if (this.orgOptions?.length) {
        if (this.orgOptions.length == 1) {
          this.org = this.orgOptions[0];
          this.handleOptionItemsStuffs();
        }
        return false
      }
      this.surveyLoading++
        let agentCardId = '';
        let agentMan = '';
        if (sessionStorage.getItem('proposerInfo')) {
            let proposerInfo = JSON.parse(sessionStorage.getItem('proposerInfo'));
            agentCardId = encryptByAES(proposerInfo.custCardId);
            agentMan = encryptByAES(proposerInfo.custContactPerson);
        }
      queryAcceptAgency({
          agentCardId,
          agentMan
      }).then(res => {
        if (res.status == '200') {
          this.orgOptions = res.data;
          // 返回的数据有多条（广州和佛山），由申请人手动选择受理机构
          // 返回的数据只有一条（其它城市），默认选中，不可编辑
          if (this.orgOptions.length == 1) {
            this.org = this.orgOptions[0];
            this.handleOptionItemsStuffs();
          }
        }
      }).finally(() => {
        this.surveyLoading--
      });

    },
    async reset(submitReset) {
      if (submitReset) {
        await this._loadSurveyInfo();
        this.handleOptionItemsStuffs();
      }
      this.handleBodyTransform();
      this.resetDialogVisible = false;
    },
    async _loadSSInfo(typeSnapSeq) {
      if (!typeSnapSeq) {
        return false;
      }
      let res = await loadSSInfo({
        bizTypeSSSeq: typeSnapSeq
      });
      if (+res.status === 200) {
        sessionStorage.setItem('sSInfo', decryptByAES(res.data));
        sSInfo = JSON.parse(decryptByAES(res.data));
      } else {
        throw new Error('获取主题快照信息失败')
      }
    },
    // 重复办件校验
    async validateRepeatItems() {
      try {
        let repeatItems = [];
        let applyerNum = '';
        let applyerName = '';
        if (sessionStorage.getItem('proposerInfo')) {
          let proposerInfo = JSON.parse(sessionStorage.getItem('proposerInfo'));
          applyerNum = encryptByAES(proposerInfo.custCardId);
          applyerName = proposerInfo.custContactPerson;
        } else {
          let userInfo = JSON.parse(decryptByAES(sessionStorage.getItem('userInfo'))).userInfo;
          applyerNum = encryptByAES(userInfo.paperCode);
          applyerName = userInfo.name;
        }
        let jcAreaSeq = ''
        if (this.baseInfo.serviceCode == 'FCZKYJS') {
          jcAreaSeq = this.jcAreaSeqs.length ? this.jcAreaSeqs[this.jcAreaSeqs.length - 1] : ''
        }else if (this.baseInfo.serviceCode == 'QYZGTXYJS') {
          jcAreaSeq = this.org?.agencyAreaCode
        }
        const loading = Loading.service();
        let items = this.baseInfo.surveyOpenChose == 1 ? this.chosenItemDirCodes : this.optionItems
        try{
          let res = await checkItemApplyEnable({
            applyerNum,
            applyerName,
            itemDirCodes: items.map(el => el.itemDirCode).join(','),
            jcAreaSeq: this.jcAreaSeqs.length ? this.jcAreaSeqs[this.jcAreaSeqs.length - 1] : '',
            typeSeq: this.baseInfo.typeSeq, // 主题流水号
          })
          if (res.status == '200' && res.data?.length) {
            // "data": [
            //   {
            //     "itemDirCode": "442169016000",
            //     "validate": "1"
            //   }
            // ]
            repeatItems = res.data.filter(el => el.validate == 0).map(el => el.itemDirCode)
          }
        } catch (e) {
        }
          loading.close();
        // 无重复事项
        if (repeatItems.length <= 0) {
          return true;
        }
        // 全部都是重复事项
        if (items.length == repeatItems.length) {
          let repeatItemsName = items.map(item => item.itemDirName).join('、');
          try {
            await MessageBox.confirm(`您已通过其他渠道申请过${repeatItemsName}，无需重复发起申请。`, "提示", {
              showClose: false,
              confirmButtonText: "我知道了",
              showCancelButton: false,
              type: 'warning',
            });
          } catch (e) {
            console.log(e);
            return false;
          }
          return false;
        }
        // 剔除事项以后，还存在有已勾选的可办事项
        if (items.length > repeatItems.length) {
          let repeatItemsName = items.filter(item => repeatItems.indexOf(item.itemDirCode) > -1).map(item => item.itemDirName).join('、');
          try {
            await MessageBox.confirm(`您已通过其他渠道申请过${repeatItemsName}，无需重复发起申请。`, "提示", {
              showClose: false,
              confirmButtonText: "我知道了，开始办理",
              cancelButtonText: '取消',
              type: 'warning',
            });
          } catch (e) {
            console.log(e);
            return false;
          }

          // 剔除校验不通过的事项
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            if (repeatItems.indexOf(item.itemDirCode) > -1) {
              if (this.baseInfo.surveyOpenChose == 1) {
                this.$refs.itemsTable.toggleRowSelection(item, false);
              } else {
                items.splice(i, 1)
                i--
              }

            }
          }
          return true;
        }
        return false;
      } catch (e) {
        console.log(e);
        this.$message.error('办件重复申请校验失败');
        return false;
      }

    },
    /**
     * 提交问卷
     */
    async submitNair() {
      let surveyOptions = [];
      let ofAgent = sessionStorage.getItem('proposerInfo') ? 1 : 0; // 是否代理人申办 0否 1是
      let ofAuth = sessionStorage.getItem("ofAuth") ? 1 : 0; // 是否授权
      let ofGuardian = ''; // 是否监护人申办 0否 1是
      if (this.openSurvey) {

        let topics = Object.values(this.topicList);
        for (let i = 0; i < topics.length; i++) {
          let topic = topics[i];
          // 用于生成快照的入参
          surveyOptions.push({
            topicSeq: topic.seq,
            topicCode: topic.topicCode,
            optionSeqs: Object.prototype.toString.call(topic.answer) === '[object Array]' ? topic.answer.join(';') : topic.answer
          });
          // 处理题目编码个性化逻辑
          // 监护人题目选择的答案保存到接口ofGuardian
          if (topic.topicCode == 'JHR' && ofAgent == 1) {
            ofGuardian = +topic.options.find(o => o.seq == topic.answer)?.autoAnswerValue;
          }

        }
      }

      // 校验重复办件
      let res = await this.validateRepeatItems();
      if (!res) {
        return false;
      }
      const loading = Loading.service();
      let items = this.baseInfo.surveyOpenChose == 1 ? this.chosenItemDirCodes : this.optionItems
      doSaveSnapshot({
        typeSeq: this.baseInfo.typeSeq, // 主题流水号
        surveySeq: this.openSurvey ? questionFormSeq : '', // 问卷信息主键编号
        surveyOptions: surveyOptions, // 智能问卷，答题选项记录
        handleType: this.openSurvey ? '3' : '1', // 办理模式（1：直接办理，2：前期辅导，3：智能引导）
        itemDirCodes: items.map(el => {
          return {
            "itemDirCode": el.itemDirCode,
            "itemDirName": el.itemDirName,
            "itemDirSeq": el.itemDirSeq
          };
        }),
        ofAuth, // 是否授权
        ofAgent, // 是否代理人申办 0否 1是
        ofGuardian // 是否监护人申办 0否 1是
      }).then(async res => {
        loading.close();
        if (+res.status === 200) {
          await this._loadSSInfo(res.data.typeSnapshotSeq);
          this.goApply();
        } else {
          throw new Error('问卷提交失败');
        }
      }).catch(err => {
        this.$message.error(err)
      })

    },
    beforeSubmitNair() {
      let params = {
        typeName: this.baseInfo.typeName || "", //主题名称
      };
      methodsBuriedPoint("YjsGuidanceDirectory", "点击”查看详情指南“", params); //进行事件埋点
      if (this.openSurvey) {
        if (this.hasTerminationTips == 1) {
          this.$message.warning('您的办理场景已终止，请重新选择导办问卷');
          return false;
        } else if (this.hasTerminationTips == 2) {
          this.$message.warning('请先完成导办问卷的必选题目');
          return false;
        }
        if (this.baseInfo.serviceCode == 'FCZKYJS' && !this.jcAreaSeqs.length
        || this.showChooseJyjgArea && !this.jyjgAreas.length
        || this.showChooseSydjArea && !this.sydjAreas.length
        || this.baseInfo.serviceCode == 'QYZGTXYJS' && !this.org) {
          this.$message.warning('请先完成导办问卷的必选题目');
          return false;
        }
      }
      if (!this.optionItems.length) {
        this.$message.warning('无可办事项，请重新选择导办问卷');
        return false;
      }
      if (this.baseInfo.surveyOpenChose == 1 && this.chosenItemDirCodes.length <= 0) {
        this.$message.warning('请勾选至少一条可办理事项');
        return false;
      }
      this.submitNair();

    },
    showResetDialog() {
      this.handleBodyTransform('add');
      this.resetDialogVisible = true;
    },
    // 获取所有选项对应的应办清单
    _querySurveyItemList(topicOptionSeqs) {
      let jcAreaSeq = ''
      let jydAreaSeq = ''
      let sydAreaSeq = ''
      if (this.baseInfo.serviceCode == 'FCZKYJS') {
        jcAreaSeq = this.jcAreaSeqs.length ? this.jcAreaSeqs[this.jcAreaSeqs.length - 1] : '' // 户籍地
        jydAreaSeq = this.jyjgAreas.length ? this.jyjgAreas[this.jyjgAreas.length - 1] : '' // 就业地
        sydAreaSeq = this.sydjAreas.length ? this.sydjAreas[this.sydjAreas.length - 1] : '' // 失业地
      }else if (this.baseInfo.serviceCode == 'QYZGTXYJS') {
        // 选了受理机构，但是受理机构的agencyAreaCode为null
        if (this.org && !this.org.agencyAreaCode) {
          this.optionItems = [];
          this.optionStuffs = [];
          return false
        }
        jcAreaSeq = this.org?.agencyAreaCode
      }
      querySurveyItemList({
        typeSeq: this.baseInfo.typeSeq,
        topicOptionSeqs: topicOptionSeqs.join(','),
        surveySeq: questionFormSeq,
        jcAreaSeq,
        jydAreaSeq, // 就业地区区划编码
        sydAreaSeq, // 失业地区区划编码
      }).then(res => {
        if (res.status == 200) {
          this.optionItems = res.data;
          this.$nextTick(() => {
            this.optionItems.forEach(item => {
              this.$refs.itemsTable.toggleRowSelection(item, true);
            });
            this._querySurveyStuffList(topicOptionSeqs);
          });
        } else {
          this.optionItems = [];
        }
      }).catch(err => {
        this.optionItems = [];
      }).finally(() => {
        this.handleJyjgAreaVisible(jydAreaSeq)
        this.handleSydjAreaVisible(sydAreaSeq)
      });
    },
    // 获取所有选项对应的应办材料
    _querySurveyStuffList(topicOptionSeqs) {
      this.optionStuffs = [];
      let items = this.baseInfo.surveyOpenChose == 1 ? this.chosenItemDirCodes : this.optionItems
      if (!items.length) {
        return false;
      }
      this.stuffLoading++;
      querySurveyStuffList({
        typeSeq: this.baseInfo.typeSeq,
        topicOptionSeqs: topicOptionSeqs.join(','),
        surveySeq: questionFormSeq,
        itemDirSeqs: items.map(el => el.itemDirSeq).join(','),
      }).then(res => {
        if (res.status == 200) {
          // 是否存在“前置事项的结果材料作为后置事项的申请材料”,存在则无需展示
          this.optionStuffs = res.data.filter(stuff => !stuff.rsRelatedFlag );
        } else {
          this.optionStuffs = [];
        }
      }).catch(err => {
        this.optionStuffs = [];
      }).finally(() => {
        this.stuffLoading--;
      });
    },
    //获取默认不隐藏的问卷列表
    async _loadSurveyInfo() {
      if (!this.openSurvey) {
        return false;
      }
      this.topicList = {};
      let surveyType = 0;
      if (this.baseInfo.surveyEnable == 1) {
        surveyType = 1;
      } else if (this.baseInfo.surveyAddEnable == 1) {
        surveyType = 2;
      }
      this.surveyLoading++
      let res = await loadSurveyInfo({
        typeSeq: this.baseInfo.typeSeq,
        typeFlag: 1,
        surveyType: surveyType // 问卷类型 1：减法，2：加法
      });
      if (res.status == 200) {
        this.handleTopics(res.data.topics)
        questionFormSeq = res.data.seq;
      }
      this.surveyLoading--
    },
    // 处理接口返回的题目列表：loadSurveyInfo/loadNextTopicByOption
    // 入参option不为空则为loadNextTopicByOption
    handleTopics(topics, option) {
      topics.forEach(topic => {
        if (!this.topicList[topic.seq]) {
          topic.preAnswer = topic.answer = topic.topicType == 1 ? '' : [];// answer当前选中答案，preAnswer上次选中答案
          topic.terminationTips = {} // 保存当前选中的选项的终止导办提示语，格式{answer: tips}
          topic.promptContents = {} // 保存当前选中的选项的提示语，格式{answer: tips}
          topic.resultDesc = {} // 保存当前选中的选项的校验结果描述，格式{answer: tips}
          topic.disabled = false // 题目不可编辑
          topic.isReply = option ? [option.seq] : [] // 当前题目由哪些选项调用loadNextTopicByOption得来
          this.handleOptionLineBreak(topic.options)
          this.$set(this.topicList, topic.seq, topic);
          this.setSpecialTopicLogic(topic);
          this.setTopicIndex();
          this.automaticSelection(topics);
        } else {
          if (this.topicList[topic.seq].isReply.indexOf(option.seq) < 0 ) {
            this.topicList[topic.seq].isReply.push(option.seq);
          }
        }
      });
    },
    // 取消选中选项
    cancelOption(topic, optionSeq) {
      // 如果该选项会终止导办，则重置
      if (topic.terminationTips[optionSeq]){
        this.$delete(topic.terminationTips, optionSeq)
      }
      // 如果该选项有提示语，则重置
      if (topic.promptContents[optionSeq]){
        this.$delete(topic.promptContents, optionSeq)
      }
      // 如果该选项有结果描述，则重置
      if (topic.resultDesc[optionSeq]){
        this.$delete(topic.resultDesc, optionSeq)
      }
      // 删除该选项对应的新增题目
      this.deleteTopic(optionSeq);
    },
    // 删除依赖于该选项(调用了loadNextTopicByOption之后)而展示的topics
    deleteTopic(optionSeq) {
      for (const seq in this.topicList) {
        const topic = this.topicList[seq];
        let index  = topic.isReply?.indexOf(optionSeq)
        if (index > -1) {
          topic.isReply.splice(index, 1)
          if (!topic.isReply.length) {
            this.$delete(this.topicList, seq);
            topic.options.forEach(option => {
              this.deleteTopic(option.seq)
            })
          }
        }
      }
    },
    async _loadNextTopicByOption(topic, option, checked) {
      // 处理已经选择过答案的情况下，取消选中选项的逻辑
      if (topic.preAnswer?.length) {
        if (topic.topicType == 2) { // 多选题
          if (!checked) {
            this.cancelOption(topic, option.seq)
          }
        } else { // 单选题
          this.cancelOption(topic, topic.preAnswer)
        }
      }
      topic.preAnswer = topic.answer
      if (topic.topicType == 2 && !checked) { // 此次为多选题取消，则不做loadNextTopicByOption
        return false;
      }
      if (option.promptContent) {
        topic.promptContents[option.seq] = option.promptContent
      }
      this.surveyLoading++
      let resultCode = await this.checkAnswer(option)
      let res = await loadNextTopicByOption({
        optionSeq: option.seq,
        resultCode
      })
      if (res.status == 200) {
        if (res.data.logicType == 1) {
          this.handleTopics(res.data.topics, option)
        } else if (res.data.logicType == 2) {
          this.$set(topic.terminationTips, option.seq, res.data.surveyStopLogicVo.stopPromptText);
        } else if (!res.data.logicType && res.data.surveyStopLogicVo?.resultDesc) {
          this.$set(topic.resultDesc, option.seq, res.data.surveyStopLogicVo.resultDesc);
        }
      }
      this.surveyLoading--

    },
    //判断是否跳转承诺书
    statementCheckConfig() {
      return new Promise((resolve, reject) => {
        loadStatementCheckConfig({
          typeSnapshotSeq: sSInfo?.seq,
        }).then(res => {
          if (res.status == 200) {
            resolve(res.data);
          } else {
            resolve(false);
          }
        }).catch(err => {
          reject(false);
        });
      });
    },

    //在线申办
    async goApply() {
      let dataStep = [];
      // sSInfo.onlineBasicInfo == 1 ? dataStep.push({ title: "基本信息", path: "/fillInBasicInfo" }) : null;
      //判断是否开启承诺书内容 commitPageEnable 是否启用回显承诺书页：0-不启用，1-启用;commitShowMode 回显模式：1-独立步骤，2-基本信息页
      if ((await this.statementCheckConfig()) && (sSInfo.commitShowMode == 1 && sSInfo.commitPageEnable == 1)) {
        dataStep.push({
          title: "告知承诺书",
          path: "/statement"
        });
      }
      dataStep.push({title: "填写一表", path: "/fillInOneForm"});
      sSInfo.busFlag ? dataStep.push({title: "工商注册", path: "/businessRegistration"}) : null;
      let res = await verifyFormAndStuff({
        typeSnapshotSeq: sSInfo.seq
      });
      if (res.status == 200) {
        sessionStorage.setItem("formAndStuff", JSON.stringify(res.data));
        let stuffFlag = res.data.stuffFlag;
        let formFlag = res.data.formFlag;
        // let expressFlag = res.data.expressFlag

        if (stuffFlag) {
          dataStep.push({title: "上传材料", path: "/uploadMaterials"});
        }
        // if (formFlag) {
        //     dataStep.push({title: "一表填写", path: "/fillInForms"})
        // }
        // if (expressFlag) {
        // dataStep.push({title: "递交/领取方式", path: "/expressWays"})
        // }
      }
      dataStep.push({title: "信息确认", path: "/confirmMessage"});
      sessionStorage.setItem("dataStep", JSON.stringify(dataStep));
      sessionStorage.setItem("typeSnapshotSeq", sSInfo.seq);
      sessionStorage.removeItem("unionControlSeq");

      if (this.baseInfo.serviceCode == 'FCZKYJS') {
        // 户籍地
        if (this.jcAreaSeqs[1] == "441900000000" || this.jcAreaSeqs[1] == "442000000000") { // 东莞/中山区级数据置空
          this.jcAreaSeqs.splice(2, 0, '')
        }
        sessionStorage.setItem('HJD', JSON.stringify(this.jcAreaSeqs));

        // 就业机构地区
        if (this.jyjgAreas[1] == "441900000000" || this.jyjgAreas[1] == "442000000000") { // 东莞/中山区级数据置空
          this.jyjgAreas.splice(2, 0, '')
        }
        sessionStorage.setItem('JYD', JSON.stringify(this.jyjgAreas));

        // 失业登记地区
        if (this.sydjAreas[1] == "441900000000" || this.sydjAreas[1] == "442000000000") { // 东莞/中山区级数据置空
          this.sydjAreas.splice(2, 0, '')
        }
        sessionStorage.setItem('SYD', JSON.stringify(this.sydjAreas));
      }

      if (this.baseInfo.serviceCode == 'QYZGTXYJS') {
        sessionStorage.setItem('SLJG', JSON.stringify(this.org));
      }

      window.location.href = `${process.env.BASE_URL}oneThingApply.html#${dataStep[0].path}`;
    },
    //监听键盘
    keyboardListen() {
      document.onkeydown = function (event) {
        var e = event || window.event;
        if (e && e.keyCode == 13) { // enter 键
          // DOMTokenList只能用contains判断是否包含该class
          if (e.target.classList.contains("checkboxOptions") || e.target.classList.contains("radioOptions")) { // 针对多选框和单选框，进行回车勾选
            e.target.click(); //模拟点击
          }
        }
      };
    },
    /**
     * @description: 是否自动选择对应选项
     */
    async automaticSelection(topics) {
      for(let i = 0; i < topics.length; i++) {
        const topic = this.topicList[topics[i].seq]
        if (topic.autoAnswerSign) {
          try {
            // 目前接口只支持对单选题做自动应答
            const res = await this._queryHandleVerify(topic.seq);
            if (topic.topicType == 1) {
              topic.answer = topic.options.find(o => o.autoAnswerValue == res).seq;
              this.radioChange(topic);
            }
            // 自动应答响应后题目是否可编辑 1可编辑 0不可编辑
            if (topic.answer && topic.answerEdit == 0) {
              topic.disabled = true
            }
          } catch (e) {
            // 校验接口超时或报错时默认选择的应答答案
            if (topic.autoAnswerValue && topic.topicType == 1) {
              topic.answer = topic.options.find(option => option.autoAnswerValue == topic.autoAnswerValue).seq;
              this.radioChange(topic);
            }
          }

        }
      }
    },
    /**
     * @description: 问卷应办事项清单校验
     * @param {String} seq 问卷题目流水号
     * @return {Boolean}
     */
    async _queryHandleVerify(seq) {
      let agentCardId = '';
      let agentMan = '';
      if (sessionStorage.getItem('proposerInfo')) {
        let proposerInfo = JSON.parse(sessionStorage.getItem('proposerInfo'));
        agentCardId = encryptByAES(proposerInfo.custCardId);
        agentMan = encryptByAES(proposerInfo.custContactPerson);
      }
      this.surveyLoading++
      const res = await queryHandleVerify({
        topicSeq: seq,
        agentCardId,
        agentMan,
      });
      this.surveyLoading--
      if (res.status == 200) {
        return res.data;
      }
    },
    /**
     * @description: 材料类型格式化
     * @param {Object} row 当前行数据
     * @param {Object} column 当前行属性
     * @param {String} cellValue 当前行值
     * @param {Number} index 当前行下标
     * @return {String}
     */
    stuffTypeFormatter(row, column, cellValue, index) {
      switch (cellValue) {
        case 1:
          return '电子件';
        case 2:
          return '纸质件';
        case 3:
          return '电子件、纸质件';
      }
    },
    /**
     * @description: 范本下载
     * @param {String} command 范本类型 1-示例范本，2-空白范本
     * @param {Object} row 行数据
     */
    handleCommand(command, row) {
      let filePath, fileName, attachType;
      if (command == '1') {
        if (!row.ylAttaPath) {
          this.$message.warning("示例范本为空！");
          return;
        }
        attachType = row.ylAttaName.split('.')[1];
        filePath = encodeURI(decryptByAES(row.ylAttaPath));
        fileName = encodeURI(row.ylAttaName);
      } else if (command == '2') {
        if (!row.kbAttaPath) {
          this.$message.warning("空白范本为空！");
          return;
        }
        attachType = row.kbAttaName.split('.')[1];
        filePath = encodeURI(decryptByAES(row.kbAttaPath));
        fileName = encodeURI(row.kbAttaName);
      }
      commonDownloadFile(attachType, fileName, filePath);
    },
    /**
     * @description: 设置题目序号
     */
    setTopicIndex() {
      let index = this.baseInfo.serviceCode == 'FCZKYJS' ? 1 : 0;// 扶残第一道题固定是户籍地，所以后面的题序号加1
      for (let seq in this.topicList) {
        if (this.topicList[seq].hiddenStatus != 2) { // 只为非永久隐藏的题目设置序号
          this.topicList[seq].index = ++index;
        }
      }
      this.extraTopicIndex = ++index;
    },
    handleOptionLineBreak(options) { // 处理选项换行
      options.forEach((option, index) => { // 选项宽度不超过590px(这里处理为不超过29个字符)的话每行展示两个,超过590px每行展示一个
        if (option.optionName.length >= 29 || option.optionName.length < 29 && options[index - 1]?.lineBreak === 0) {
          option.lineBreak = 1 // lineBreak表示为是否在该选项后换行
        } else {
          option.lineBreak = 0
        }
      });
    },
    /**
     * @description: 特殊处理的题目：TRDB题目/JHR题目根据是否代办自动选择
     * @param {Object} topic 题目数据
     */
    setSpecialTopicLogic(topic) {
      if (topic.topicCode == "SFSQ") { // 是否已完成授权
        if (sessionStorage.getItem("ofAuth")) {
          topic.answer = topic.options.find(o => o.optionName == '是').seq;
        } else {
          topic.answer = topic.options.find(o => o.optionName == '否').seq;
        }
        this.radioChange(topic);
      } else if (topic.topicCode == "NM18") { // 申请人是否年满18周岁
        let idCard = ''
        if (sessionStorage.getItem('proposerInfo')) {
          let proposerInfo = JSON.parse(sessionStorage.getItem('proposerInfo'));
          idCard = proposerInfo.custCardId
        } else {
          let userInfo = JSON.parse(decryptByAES(sessionStorage.getItem('userInfo'))).userInfo;
          idCard = userInfo.paperCode
        }
        if (analyzeIDCardAge(idCard)) {
          topic.answer = topic.options.find(o => o.optionName == '是').seq;
        } else {
          topic.answer = topic.options.find(o => o.optionName == '否').seq;
        }
        this.radioChange(topic);
      } else if (topic.topicCode == "JHR") { // 是否监护人代办,规则：①授权页选择本人办理时，自动回填“否”；②授权页选择代他人办理时，无需回填
        if (!sessionStorage.getItem('proposerInfo')) {
          topic.answer = topic.options.find(o => o.optionName == '否').seq;
          this.radioChange(topic);
        }

      } else if (topic.topicCode == "TRDB") { // 是否他人代办
        if (sessionStorage.getItem('proposerInfo')) {
          topic.answer = topic.options.find(o => o.optionName == '是').seq;
        } else {
          topic.answer = topic.options.find(o => o.optionName == '否').seq;
        }
        this.radioChange(topic);
      } else if (topic.topicCode == "CJRLB" && cjrInfo?.CJLB) { // 残疾类别,先默认返回单个类别
        let option = topic.options.filter(o => cjrInfo.CJLB.indexOf(o.autoAnswerValue) > -1)[0];
        topic.answer = [option.seq]
        this.checkboxChange(topic, option, true);// topic, option, checked
      }
      if (topic.answer?.length) {
        topic.disabled = true
      }
    },

    // 获取残疾人基本信息
    _loadCJRInfo() {
      loadCJRInfo().then(res => {
        if (+res.status === 200 && res.data) {
          cjrInfo = res.data
        }
      })
    },
    // 调用公安户籍地信息接口获取户籍地
    async _getResidentPopulationInfo() {
      let idCardNum = ''
      let name = ''
      if (sessionStorage.getItem('proposerInfo')) {
        let proposerInfo = JSON.parse(sessionStorage.getItem('proposerInfo'));
        idCardNum = proposerInfo.custCardId;
        name = proposerInfo.custContactPerson;
      } else {
        let userInfo = JSON.parse(decryptByAES(sessionStorage.getItem('userInfo'))).userInfo;
        idCardNum = userInfo.paperCode;
        name = userInfo.name;
      }
      try {
        let res = await getResidentPopulationInfo({
          idCardNum,
          name,
        })
        if (res.status == "200" && res.data) {
          this.jcAreaSeqs = res.data.areaCodeList || []
          this.cascaderKey = Math.random()
        }
      } catch (e) {
          console.log(e)
      }
    },
    handleJyjgAreaVisible(hasJyjgParam) {
      if (this.baseInfo.serviceCode == 'FCZKYJS' && this.openSurvey) {
        if (this.hasTerminationTips == 0 && (hasJyjgParam || this.optionItems?.some(itemDir => itemDir.itemDirCode == '442111731009'))) { // 完成问卷，且包含关联事项：就业困难人员认定
          this.showChooseJyjgArea = true
        } else {
          this.showChooseJyjgArea = false
          this.jyjgAreas = []
        }
      } else {
        this.showChooseJyjgArea = false
        this.jyjgAreas = []
      }
    },
    handleSydjAreaVisible(hasSydjParam) {
      if (this.baseInfo.serviceCode == 'FCZKYJS' && this.openSurvey) {
        if (this.hasTerminationTips == 0 && (hasSydjParam || this.optionItems?.some(itemDir => itemDir.itemDirCode == '442111836002'))) { // 完成问卷，且包含关联事项：失业登记
          this.showChooseSydjArea = true
        } else {
          this.showChooseSydjArea = false
          this.sydjAreas = []
        }
      } else {
        this.showChooseSydjArea = false
        this.sydjAreas = []
      }
    },
  },
  async created() {
    this.keyboardListen(); //监听键盘事件
    await this._loadSurveyInfo();
    if (this.baseInfo.surveyAddEnable != 1) {
      this.handleOptionItemsStuffs();
    }
    if (this.baseInfo.serviceCode == 'FCZKYJS') {
      this._loadCJRInfo()
      // 从公安接口信息中复用户籍地
      // this._getResidentPopulationInfo()
    }
  },
  async activated() {
    let baseInfo = JSON.parse(sessionStorage.getItem('baseInfo'));
    if (baseInfo.typeSeq != this.baseInfo.typeSeq) {
      this.baseInfo = baseInfo;
      await this._loadSurveyInfo();
      if (this.baseInfo.surveyAddEnable != 1) {
        this.handleOptionItemsStuffs();
      }

    }
  },
  components: {Banner, ShowMore},
  mounted() {
    // 进行埋点，记录页面事件
    let obj = {
      title: document.title || "", //页面名称
      actionId: "YjsIntellectGuidance", //事件ID
      account: "ThemeItem", //系统标识
    };
    buriedPointFunc(obj);
  },
  destroyed() {
  }
};
</script>

<style lang="scss" scoped>
.question-nair {
  padding-bottom: 90px;

  .banner-title {
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0D1C28;
    line-height: 56px;

    .banner-info {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #565B5F;
      line-height: 25px;
      margin-top: 10px;
    }
  }

  .warning-panel {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F13939;
    line-height: 24px;
    padding-bottom: 15px;
    display: flex;

    .icon {
      margin-right: 5px;
    }

    &.no-stop {
      color: #3e97df;
    }
  }

  .title-btn {
    width: 128px;
    height: 38px;
    background: #EBF4FB;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: $color-primary;
    float: right;
    margin-top: 10px;
  }

  .question-content {

    ul.content-box {
      li {
        margin-bottom: 25px;

        &:last-child {
          margin-bottom: 0;
        }

        .question {
          font-size: 18px;
          font-weight: 400;
          color: #0D1C28;
          line-height: 24px;

          > i.common-required {
            display: inline-block;
            color: #fb3b2d;
            font-size: 16px;
          }

          > span {
            font-size: 18px;
            font-weight: 400;
            line-height: 20px;
            color: rgba(153, 153, 153, 1);
          }
        }

        .question-tips{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #727475;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          margin-top: 10px;
        }

        .question-remark {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFangSC;
          font-weight: 400;
          color: rgba(114, 116, 117, 1);
          margin-top: 12px;
        }

        .checkboxOptions {
          .checkbox__isChecked {
            position: absolute;
            right: -12px;
            bottom: -17px;
            width: 26px;
            height: 46px;
            background: $color-primary;
            text-align: center;
            transform: rotate(45deg);
            box-shadow: 0 1px 1px #ccc;

            .el-icon-check {
              font-size: 6px;
              font-weight: bold;
              color: #fff;
              transform: rotate(-45deg);
              margin-top: 20px;
              margin-right: 12px;
            }
          }

          .el-checkbox__label {
            white-space: pre-wrap;
            word-break: normal;
            word-wrap: break-word;
            vertical-align: top;
          }
        }
      }

      .area-cascader {
        width: 600px;
        margin-top: 20px;

        /deep/ .el-input {
          line-height: 48px;

          input {
            height: 48px;
            line-height: 48px;
            border-radius: 4px;
            border: 1px solid #DDDDDD;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #45484B;
          }
        }
      }
    }

    .radio-row, .checkbox-row {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 24px;
      color: rgba(13, 28, 40, 1);
    }

    .checkbox-row {
      margin-top: 16px;
    }
  }

  .table-title-name {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #0D1C28;
    line-height: 24px;
    margin-top: 40px;
    margin-bottom: 20px;
  }

  .check-detail-guide {
    position: relative;

    .check-detail-guide-tips {
      position: absolute;
      width: 380px;
      bottom: 45px;
      right: 0;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: $color-primary;
      line-height: 22px;
      background: #FFFFFF;
      box-shadow: 0px 2px 15px 0px rgba(9, 41, 77, 0.15);
      padding: 13px 16px;

      .el-icon-warning-outline {
        font-size: 24px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
      }

      .check-detail-guide-tips-text {
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
      }

      .el-icon-close {
        display: inline-block;
        vertical-align: middle;
        color: #999999;
        cursor: pointer;
      }
    }

    .check-detail-guide-tips::after {
      content: '';
      width: 0;
      height: 0;
      border: 8px solid;
      position: absolute;
      bottom: -15px;
      right: 40px;
      border-color: #fff transparent transparent;
    }
  }

  .stuff-name {
    margin-right: 10px;
    max-width: calc(100% - 68px)
  }

  .stuff-tab {
    display: inline-block;

    height: 22px;
    line-height: 22px;
    border-radius: 11px;
    padding: 0 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin-right: 10px;
  }

  .stuff-tab-blue {
    background: rgba($color: #3E97DF, $alpha: 0.1);
    color: #3E97DF;
  }

  .stuff-tab-green {
    background: rgba(2, 172, 0, 0.1);
    color: #02AC00;
  }

  .common-stripe-table {
    /deep/ .el-table__body {
      .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
        background-color: #3E97DF;
        border-color: #3E97DF;
      }

      .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
        border-color: #FFFFFF;
      }
    }

    /deep/ .el-checkbox__inner {
      width: 18px;
      height: 18px;

      &::after {
        left: 6px;
        top: 3px;
      }

      &::before {
        top: 7px;
      }
    }

    /deep/ .el-table__body-wrapper {
      .el-table__row {
        height: 80px;
      }
    }
  }
}
/deep/.el-loading-mask{
  z-index: 1;
}
</style>
<style lang="scss">
.question-nair {
  .content-box {
    .el-radio, .el-checkbox {
      height: 46px;
      line-height: 46px;
      margin-right: 20px;
      margin-bottom: 15px;
      background: #F1F2F4;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      border: 2px solid #F1F2F4;
      border-radius: 4px;
    }

    .el-radio.is-checked, .el-checkbox.is-checked {
      border: 2px solid $color-primary;
      background: #FFFFFF;
    }

    .el-radio {
        min-width: 188px;
        box-sizing: border-box;
        padding: 0 20px;

      .el-radio__inner {
        width: 20px;
        height: 20px;

        &::after {
          width: 8px;
          height: 8px;
        }
      }
    }

    .el-checkbox {
      min-width: 188px;
      box-sizing: border-box;
      padding: 0 20px;
      overflow: hidden;
    }

    .el-checkbox__input {
      display: none;
    }

    .el-checkbox__label {
      padding-left: 0;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap
    }

    .el-checkbox__label, .el-radio__label {
      font-size: 18px;
      font-weight: 400;
      color: #0D1C28;
      line-height: 46px;
      vertical-align: bottom;
    }

    .radio-row {
      margin-top: 10px;
    }
  }

  .stuff-loading.el-loading-mask {
    background-color: rgba(255, 255, 255, .6);

    .el-loading-text {
      color: #0D1C28;
      font-size: 16px;
      margin-top: 10px;
    }
  }
}

.custom-dropdown {
  border-radius: 0;
  box-shadow: 0px 2px 15px 0px rgba(13, 28, 40, 0.1);

  .el-dropdown-menu__item {
    font-size: 16px;
    color: #0D1C28;
    line-height: 38px;
    padding: 0 28px;

    &:not(.is-disabled):hover {
      background: #F1F2F3;
      color: #0D1C28;
    }
  }
}
</style>
